import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { roofAndMirrorCaps } from '../../../../reducers/roofAndMirrorCaps/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import { getDropdownOptions } from '../enhance';

const mapStateToProps = combineSelectors({
  roofAndMirrorCaps,
});

const options = ({ roofAndMirrorCaps, availableOptions }) =>
  getDropdownOptions(roofAndMirrorCaps, availableOptions);

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['roofAndMirrorCapFormPlaceHolder'] }),
  connect(mapStateToProps),
  addProps({ options }),
);
